export type TabId = 'today' | 'forest' | 'settings';

export interface AppState {
  activeTab: TabId;
  user: { id: string; email: string };
}

const listeners = new Set<() => void>();
let state: AppState | null = null;

export function setState(next: AppState) {
  state = next;
  for (const fn of listeners) fn();
}

export function getState(): AppState {
  if (!state) throw new Error('AppState not initialized');
  return state;
}

export function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

export function switchTab(tab: TabId) {
  if (!state) return;
  setState({ ...state, activeTab: tab });
}
